export default __webpack_public_path__ + "static/media/american.aa3d0074.svg";